/**
 * 统一的日志工具
 * 支持开发/生产环境控制，便于调试和问题排查
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var isDevelopment = process.env.NODE_ENV === 'development';
/**
 * 日志级别
 */
export var LogLevel;
(function (LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARN"] = "WARN";
    LogLevel["ERROR"] = "ERROR";
})(LogLevel || (LogLevel = {}));
var defaultConfig = {
    enabled: isDevelopment,
    level: LogLevel.INFO,
};
/**
 * 日志工具类
 */
var Logger = /** @class */ (function () {
    function Logger(prefix, config) {
        if (prefix === void 0) { prefix = ''; }
        this.prefix = prefix;
        this.config = __assign(__assign({}, defaultConfig), config);
    }
    Logger.prototype.shouldLog = function (level) {
        if (!this.config.enabled)
            return false;
        var levels = [LogLevel.DEBUG, LogLevel.INFO, LogLevel.WARN, LogLevel.ERROR];
        var currentLevelIndex = levels.indexOf(this.config.level);
        var messageLevelIndex = levels.indexOf(level);
        return messageLevelIndex >= currentLevelIndex;
    };
    Logger.prototype.formatMessage = function (level, message) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        if (!this.shouldLog(level))
            return;
        var prefix = this.prefix ? "[".concat(this.prefix, "]") : '';
        var logMessage = "".concat(prefix, " ").concat(message);
        switch (level) {
            case LogLevel.DEBUG:
                console.log.apply(console, __spreadArray(["\uD83D\uDD0D ".concat(logMessage)], args, false));
                break;
            case LogLevel.INFO:
                console.log.apply(console, __spreadArray(["\u2139\uFE0F ".concat(logMessage)], args, false));
                break;
            case LogLevel.WARN:
                console.warn.apply(console, __spreadArray(["\u26A0\uFE0F ".concat(logMessage)], args, false));
                break;
            case LogLevel.ERROR:
                console.error.apply(console, __spreadArray(["\u274C ".concat(logMessage)], args, false));
                break;
        }
    };
    Logger.prototype.debug = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.formatMessage.apply(this, __spreadArray([LogLevel.DEBUG, message], args, false));
    };
    Logger.prototype.info = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.formatMessage.apply(this, __spreadArray([LogLevel.INFO, message], args, false));
    };
    Logger.prototype.warn = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.formatMessage.apply(this, __spreadArray([LogLevel.WARN, message], args, false));
    };
    Logger.prototype.error = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.formatMessage.apply(this, __spreadArray([LogLevel.ERROR, message], args, false));
    };
    /**
     * 创建带前缀的日志实例
     */
    Logger.prototype.createChild = function (prefix) {
        var fullPrefix = this.prefix ? "".concat(this.prefix, ":").concat(prefix) : prefix;
        return new Logger(fullPrefix, this.config);
    };
    return Logger;
}());
/**
 * 创建日志实例
 */
export function createLogger(prefix, config) {
    if (prefix === void 0) { prefix = ''; }
    return new Logger(prefix, config);
}
/**
 * 默认日志实例
 */
export var logger = createLogger('StoreRevenueMonitor');
